import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'

import Button from 'client/shared/blocks/button'
import Spacer from 'client/shared/blocks/spacer'
import SVGInline from 'react-svg-inline'

import './empty-state.styl'

type Link = {
  path: string
  text: string
}

type Props = {
  message: string
  icon?: React.ReactNode
  link: Link
}

class EmptyState extends Component<Props> {
  render(): JSX.Element {
    const { icon, message, link } = this.props

    return (
      <div className="empty-state">
        <Spacer size={8} />
        <div className="empty-state__wrapper">
          {icon && <SVGInline svg={icon as string} />}
          <div className="empty-state__message">{message}</div>
          {!isEmpty(link) && (
            <Button path={link.path} kind="primary" aria-label={link.text}>
              <span>{link.text}</span>
            </Button>
          )}
        </div>
        <Spacer />
      </div>
    )
  }
}

export default EmptyState
